/* eslint-disable no-negated-condition */
/* eslint-disable react/prop-types */
/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';

import Modal from '../../components/Modal';
import SignupModal from '../../components/Modal/SignupModal';
import MobileNumberModal from '../../components/Modal/MobileNumberModal';
import SubscriptionGrid from '../../../shared/components/SubscriptionGrid';
import _ from 'lodash';
import { closeModal } from '../../../../lib/closeModal';
import LoadingSpinner from '../../components/Spinners/LoadingSpinner.js';
import InstanceSubscribeModal from '../../components/Modal/InstanceSubscribeModal';
import ServiceSeverityGrid from '../SubscribeModal/components/ServiceSeverityGrid';
import SubscriptionAdded from '../../components/Modal/SubscriptionAdded.js';

class SubscribeModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: '',
      email: '',
      phoneNumber: '',
      emailVerified: false,
      mobileNumberVerified: false,
      smsCheckBox: false,
      emailCheckBox: false,
      countryCode: '1',
      verificationCode: '',
      submitted: false,
    };
    this.changeModal = this.changeModal.bind(this);
    this.onEmailChange = this.onEmailChange.bind(this);
    this.clickSubmit = this.clickSubmit.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
    this.onCodeChange = this.onCodeChange.bind(this);
    this.onKeyPressVerfication = this.onKeyPressVerfication.bind(this);
    this.submitVerificationCode = this.submitVerificationCode.bind(this);
    this.clickTogglePhoneNumber = this.clickTogglePhoneNumber.bind(this);
    this.onCountryCodeChange = this.onCountryCodeChange.bind(this);
    this.toggleEmail = this.toggleEmail.bind(this);
    this.toggleSMS = this.toggleSMS.bind(this);
    this.submitPreferenceNotification = this.submitPreferenceNotification.bind(this);
    this.previousModal = this.previousModal.bind(this);
    this.resendVerificationCode = this.resendVerificationCode.bind(this);
  }
  submitPreferenceNotification() {
    this.setState({ submitted: true, modal: 'grid' });
  }

  previousModal() {
    this.setState({ modal: 'mobile' });
  }
  toggleEmail(event) {
    this.setState({ emailCheckBox: !this.state.emailCheckBox });
  }

  toggleSMS(event) {
    this.setState({ smsCheckBox: !this.state.smsCheckBox });
  }
  onCountryCodeChange(event) {
    this.setState({ countryCode: event.target.value });
  }
  clickTogglePhoneNumber(event) {
    this.setState({ togglePhoneNumber: !this.state.togglePhoneNumber });
  }
  onKeyPress(event) {
    if (event.key === 'Enter') {
      this.clickSubmit();
    }
  }
  onKeyPressVerfication(event) {
    if (event.key === 'Enter') {
      this.submitVerificationCode();
    }
  }
  submitVerificationCode() {
    const payload = {
      emailAddress: this.props.requests.subscriber.value.emailAddress,
      verificationCode: this.state.verificationCode
    };
    this.props.requests.verifyUser.handleRequest({ body: payload }).then(() => {
      this.props.requests.subscriber.handleRequest();
    })
    .catch(() => {
      this.props.requests.subscriber.handleRequest();
      this.props.onClose('failure', 'There was an error. Please try again');
    });
  }
  onCodeChange(event) {
    // If currently invalid then check for validity
    const number = event.target.value;
    this.setState({ verificationCode: number });
  }
  onEmailChange(event) {
    // If currently invalid then check for validity
    const number = event.target.value;
    this.setState({ phoneNumber: number });
  }
  clickSubmit() {
    this.setState({ submitted: true });
    // If email or subscription is invalid do not submit
    const payload = {
      emailAddress: this.props.requests.subscriber.value.emailAddress,
      phoneNumber: this.state.countryCode + this.state.phoneNumber
    };
    this.props.requests.addNumber.handleRequest({ body: payload }).then(() => {
      this.props.requests.subscriber.handleRequest();
    });
  }
  resendVerificationCode() {
    this.setState({ submitted: true });
    const payload = {
      emailAddress: this.props.requests.subscriber.value.emailAddress,
      phoneNumber: this.props.requests.subscriber.value.phoneNumber
    };
    this.props.requests.addNumber.handleRequest({ body: payload }).then(() => {
      this.props.requests.subscriber.handleRequest();
    });
  }

  changeModal(str) {
    this.setState({ modal: str });
  }
  componentDidMount() {
    const { token, history, requests } = this.props;
    // If no token is set, redirect to login page
    if(token === null || token === undefined){
      this.setState({ modal: 'signup' });
    } else {
      requests.subscriber.handleRequest().then((res) => {
        // if no response, there was an error due to invalid token
        if (!res || !res.emailAddress || !res.emailVerified) {
          this.setState({ modal: 'signup' });
        } else if (!res.mobileNumberVerified) {
          this.setState({
            emailAddress: res.emailAddress,
            phoneNumber: res.phoneNumber,
            emailVerified: res.emailVerified,
            modal: 'mobile'
          });
        } else {
          this.setState({
            emailAddress: res.emailAddress,
            emailVerified: res.emailVerified,
            phoneNumber: res.phoneNumber,
            mobileNumberVerified: res.mobileNumberVerified, // set the state here
            modal: 'mobile'
          });
        }
      });
    }
  }

  render() {
    const { history, requests, token } = this.props;
    const instanceKey = this.props.match.params.aliasKey;
    if (!requests.instanceInfo.isCompleted) return <LoadingSpinner inverse />;

    const back = (e) => {
      e.stopPropagation();
      closeModal(history);
    };

    return (
      <Modal onClose={back}>
        {this.state.modal === 'signup' && (
          <SignupModal
            isOpen={true}
            closeModal={back}
            requests={this.props.requests}
            instanceKey={instanceKey}
          />
        )}

        {this.state.modal === 'mobile' && (
          <MobileNumberModal
            isOpen={true}
            closeModal={back}
            requests={this.props.requests}
            changeModal={this.changeModal}
            emailAddress={this.state.emailAddress}
            phoneNumber={this.state.phoneNumber}
            emailVerified={this.state.emailVerified}
            mobileNumberVerified={this.state.mobileNumberVerified}
            smsCheckBox={this.state.smsCheckBox}
            emailCheckBox={this.state.emailCheckBox}
            toggleEmail={this.toggleEmail}
            toggleSMS={this.toggleSMS}
            instanceKey={instanceKey}
            onEmailChange={this.onEmailChange}
            onKeyPress={this.onKeyPress}
            onCodeChange={this.onCodeChange}
            onKeyPressVerfication={this.onKeyPressVerfication}
            resendVerificationCode={this.resendVerificationCode}
            submitVerificationCode={this.submitVerificationCode}
            clickSubmit={this.clickSubmit}
            submitPreferenceNotification={this.submitPreferenceNotification}
          />
        )}
        {this.state.modal === 'grid' && (
          <ServiceSeverityGrid
            closeModal={back}
            instanceKey={instanceKey}
            requests={this.props.requests}
            serviceSeverityGrid={this.props.serviceSeverityGrid}
            changeModal={this.changeModal}
            previousModal={this.previousModal}
            smsCheckBox={this.state.smsCheckBox}
            emailCheckBox={this.state.emailCheckBox}
          />
        )}
        {this.state.modal === 'success' && (
          <SubscriptionAdded
            closeModal={back}
          />
        )}
      </Modal>
    );
  }
}

export default SubscribeModal;
